export default {
  title: 'เจ้าของร่วม',
  description: 'จัดการเจ้าของร่วม (เจ้าของนิติบุคคล) ของหน่วยคอนโดมิเนียมของคุณ',

  labels: {
    first_name: 'ชื่อ',
    last_name: 'นามสกุล',
    phone: 'โทรศัพท์',
    email: 'อีเมล',
    id_card_number: 'บัตรประชาชน',
    tax_id: 'เลขประจำตัวผู้เสียภาษี',
    address: 'ที่อยู่',
    line_id: 'LINE ID',
    property: 'อสังหาริมทรัพย์',
    unit: 'หน่วย',
    started_at: 'ตั้งแต่',
    ended_at: 'วันที่สิ้นสุด',
    usage_status: 'สถานะการใช้งาน',
    // EP-111 amendment (payment info) — ข้อมูลการชำระเงินสำหรับเรียกเก็บค่าส่วนกลาง
    payment_info: 'ข้อมูลการชำระเงิน',
    bank_name: 'ธนาคาร',
    bank_account_number: 'เลขที่บัญชี',
    bank_account_holder: 'ชื่อบัญชี',
    promptpay_target: 'พร้อมเพย์ (เบอร์โทร / บัตรประชาชน / รหัสบิลเพย์เมนต์)',
  },

  placeholders: {
    search: 'ค้นหา หน่วย / ชื่อเจ้าของร่วม...',
    first_name: 'ชื่อ',
    last_name: 'นามสกุล',
    phone: '0812345678',
    email: 'email@example.com',
    bank_name: 'ธนาคารกรุงเทพ',
    bank_account_number: '123-4-56789-0',
    bank_account_holder: 'ชื่อ-นามสกุลเจ้าของร่วม',
    promptpay_target: '0812345678',
  },

  status: {
    owner_occupied: 'อยู่เอง',
    available_for_rent: 'ว่าง–ให้เช่า',
    rented: 'ปล่อยเช่า',
    for_sale: 'ประกาศขาย',
  },

  // D15 read-only-when-derived: เมื่อ effective_usage_status === 'rented' จะซ่อน
  // <select> ในฟอร์มและแสดงป้ายล็อกพร้อมคำอธิบายนี้แทน เพราะสถานะนี้คำนวณจาก
  // สัญญาเช่าผู้เช่าที่ยัง active อยู่ ผู้ใช้ไม่สามารถแก้ไขจากฟอร์มนี้ได้โดยตรง
  // (ต้องไปสิ้นสัญญาเช่าที่หน้าจัดการสัญญาเช่า)
  derived_status: {
    label: 'สถานะปัจจุบัน',
    explanation: 'ปล่อยเช่า (คำนวณจากสัญญาเช่าที่ยังดำเนินอยู่)',
  },

  tabs: {
    all: 'ทั้งหมด',
    owner_occupied: 'อยู่เอง',
    available_for_rent: 'ว่าง–ให้เช่า',
    rented: 'ปล่อยเช่า',
    for_sale: 'ประกาศขาย',
  },

  sections: {
    recent: 'ล่าสุด',
  },

  actions: {
    add_co_owner: 'เพิ่มเจ้าของร่วม',
    create_co_owner: 'สร้างเจ้าของร่วม',
    edit: 'แก้ไขเจ้าของร่วม',
    end: 'สิ้นสุดเจ้าของร่วม',
    save_changes: 'บันทึกการเปลี่ยนแปลง',
    // EP-134 §7 — โอนกรรมสิทธิ์
    transfer_ownership: 'โอนกรรมสิทธิ์',
  },

  empty: {
    no_results: 'ไม่พบเจ้าของร่วม',
  },

  // EP-135 Tier 0 — สมุดรายชื่อเจ้าของร่วม (หน้าแยก)
  // รายการแบบอ่านอย่างเดียวจัดเป็นตาราง (หนึ่งแถวต่อ OwnerContract ที่ยัง active)
  // กรองตามอสังหาริมทรัพย์ โทรศัพท์และอีเมลเป็นลิงก์โทร/ส่งเมล เพื่อให้ผู้ดูแลจัดการ
  // การแจ้งเตือนการประชุม AGM ได้โดยไม่ต้องค้นหาแยก
  // Tier 1/2 จะใช้ roll เดียวกัน (ผ่าน SharedOwnerRoll.for(property, as_of:))
  // เพื่อ snapshot ณ วันแจ้ง/วันโหวต
  directory: {
    title: 'สมุดรายชื่อเจ้าของร่วม',
    description:
      'รายชื่อติดต่อเจ้าของร่วม (นิติบุคคล) ในแต่ละอสังหาริมทรัพย์คอนโดมิเนียม สำหรับแจ้งเตือน AGM และเลือกตั้งกรรมการ',
    column_unit: 'ห้อง',
    column_name: 'ชื่อ',
    column_share_ratio: 'สัดส่วน',
    column_contact: 'ติดต่อ',
    share_ratio_value: '{{value}}%',
    call: 'โทร',
    email: 'อีเมล',
    no_phone: 'ไม่มีเบอร์โทรในระบบ',
    no_email: 'ไม่มีอีเมลในระบบ',
    property_filter_label: 'อสังหาริมทรัพย์',
    property_filter_all: 'ทุกอสังหาริมทรัพย์',
    empty_state:
      'ยังไม่มีเจ้าของร่วมให้แสดง เพิ่มจากหน้าเจ้าของร่วม รายชื่อจะปรากฏที่นี่โดยอัตโนมัติ',
  },

  setup_guide: {
    title: 'ยินดีต้อนรับสู่เจ้าของร่วม',
    description:
      'เจ้าของร่วมคือเจ้าของนิติบุคคลของหน่วยคอนโดมิเนียมของคุณ เพิ่มรายชื่อที่นี่เพื่อเรียกเก็บค่าส่วนกลาง (CAF)',
    step_1_title: 'ตั้งค่าอสังหาริมทรัพย์เป็นคอนโดมิเนียม',
    step_1_description: 'ไปที่แท็บราคาของอสังหาริมทรัพย์แล้วตั้งค่าประเภทเป็นคอนโดมิเนียม',
    step_2_title: 'เพิ่มเจ้าของร่วม',
    step_2_description: 'กรอกข้อมูลเจ้าของร่วมและเลือกหน่วยของพวกเขา',
  },

  messages: {
    created: 'สร้างเจ้าของร่วมสำเร็จ',
    updated: 'แก้ไขเจ้าของร่วมสำเร็จ',
    ended: 'สิ้นสุดเจ้าของร่วมสำเร็จ',
    end_title: 'สิ้นสุดเจ้าของร่วม',
    end_confirm: 'สิ้นสุดเจ้าของร่วม "{{name}}"? การเรียกเก็บค่าส่วนกลางจะหยุดตั้งแต่รอบถัดไป',
    identifier_required: 'กรุณากรอกอย่างน้อยชื่อ เบอร์โทร หรืออีเมล เพื่อให้สามารถระบุเจ้าของร่วมได้',
    unit_required: 'กรุณาเลือกหน่วย',
    // EP-134 §4 — ฟอร์มโอนกรรมสิทธิ์ (typed 422 codes from
    // OwnerTransferService::TransferError). §9 Q-5: หน้าจอยืนยันเงียบเรื่องเงิน
    // โดยตั้งใจ — ค่าส่วนกลางค้าง/ล่วงหน้าตกลงกันที่สำนักงานที่ดิน
    transfer: {
      title: 'โอนกรรมสิทธิ์',
      description:
        'บันทึกการโอนกรรมสิทธิ์ห้องชุด สัญญาของเจ้าของเดิมจะสิ้นสุดลงและสัญญาของผู้ซื้อจะเริ่มตั้งแต่วันที่โอน',
      transfer_date_label: 'วันที่โอน',
      transfer_date_help: 'วันที่จดทะเบียนที่สำนักงานที่ดิน ย้อนหลังได้ ล่วงหน้าไม่ได้',
      to_section_label: 'เจ้าของใหม่',
      to_create_option: 'สร้างเจ้าของร่วมใหม่',
      to_pick_option: 'เลือกจากบุคคลที่มีอยู่',
      pick_customer_label: 'บุคคลที่มีอยู่',
      create_success: 'โอนกรรมสิทธิ์เรียบร้อย',
      tenant_warning: 'สัญญาเช่าของผู้เช่าในหน่วยนี้ต้องปรับ — การโอนไม่กระทบสัญญาเช่า',
      committee_warning: 'เจ้าของเดิมดำรงตำแหน่งกรรมการ — การสิ้นสุดกรรมสิทธิ์ไม่ปลดตำแหน่งโดยอัตโนมัติ',
      errors: {
        buyer_required: 'กรุณาเลือกบุคคลที่มีอยู่ หรือกรอกข้อมูลเจ้าของร่วมใหม่',
        buyer_phone_required: 'ต้องระบุเบอร์โทรของเจ้าของใหม่ — ใช้สำหรับล็อกอินและ OTP',
        transfer_date_required: 'กรุณาเลือกวันที่โอน',
        transfer_date_in_future: 'วันที่โอนต้องไม่เป็นวันในอนาคต',
        transfer_date_before_outgoing_started_at: 'วันที่โอนต้องไม่ก่อนวันที่เจ้าของเดิมเริ่มสัญญา',
        no_active_owner_contract: 'หน่วยนี้ไม่มีเจ้าของร่วมที่ active ให้โอน',
        owner_transfer_requires_condominium_property: 'โอนกรรมสิทธิ์ได้เฉพาะหน่วยในอสังหาริมทรัพย์ประเภทคอนโดมิเนียม',
        buyer_equals_seller: 'เจ้าของใหม่ต้องไม่ใช่เจ้าของเดิม',
        customer_not_found: 'บุคคลนี้ไม่ได้อยู่ในบัญชีนี้',
      },
    },
    // EP-134 §2b — บล็อกประวัติกรรมสิทธิ์บนหน้ารายละเอียดหน่วย
    history: {
      title: 'ประวัติกรรมสิทธิ์',
      until_now: 'ถึงปัจจุบัน',
      until: 'ถึง {{date}}',
      from: 'ตั้งแต่ {{date}}',
      transferred_from_tooltip: 'กรรมสิทธิ์นี้ถูกโอนไปยังเจ้าของร่วมถัดไป',
    },
  },
}
